module.exports = __webpack_public_path__ + "static/media/two.7959d74b.ogg";